module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2e"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("A Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "center-parax"
  }, [_c('em', [_vm._v("For my Children-Nathan, Erin, Apryl and Joy who is in Heaven with Papa")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I dedicate this book to you, my blessings, the loves of my life and the very reasons for my speaking the simple truth of a lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The journey has been arduous dear ones, but every word written has come from my heart: A heart that now bears the evidence of an incredible process of healing, a heart that loves you more now than I ever thought possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Why? Because I dared to ask God; why did I fall victim to the predators of the world? His answer came in the form of a journey back through time to my childhood, where most of our tragic hurts derive from... where most of yours have come from.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This book is a legacy of love, from Our Papa to me and from me to you. A hand-me-down of precious treasures unveiled and revealed from a mother to her children. If I leave you nothing else from my life on this earth, at least I will have shared the simple truth I have found in learning of God’s love for His children, each and every one. A redeeming love that surpasses the understanding of most mere mortals, but when we take the time to discover how simple His love is, it is amazing how rarified the air around us becomes. It is amazing how crystal clear everything in our daily life becomes. It is amazing how much more we can love when the cobwebs are swept away.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Trust in Him and He will make the way clear")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3392cf41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter05.vue
// module id = 72
// module chunks = 0